module.exports = __webpack_public_path__ + "img/header-slide-2-m@2x.e2dc91c4.png";